module.exports = __webpack_public_path__ + "img/locker.0762364f.jpg";